export default __webpack_public_path__ + "static/media/city.e17cadd6.png";